import loopMap from 'mn-utils/loopMap';
import faker from '@faker-js/faker';
import {TListItem, TUserDetails} from './types';

export const getUserList = (limit: number): TListItem[] => {
  return loopMap(limit, getUserDetails) as TListItem[];
};

export const getUserDetails = (): TUserDetails => {
  return {
    id: faker.datatype.uuid(),
    email: faker.internet.email(),
    name: faker.name.findName(),
    role: faker.name.findName(),
    settings: {
      dashboard: faker.datatype.boolean(),
      currency_trend_chart: faker.datatype.boolean(),
      sales_overview: faker.datatype.boolean(),
      payout_history: faker.datatype.boolean(),
      withdraw: faker.datatype.boolean(),
      notification_settings: faker.datatype.boolean(),
      access_permissions: faker.datatype.boolean(),
      edit_bank_details: faker.datatype.boolean(),
      settlement_and_refund_preference: faker.datatype.boolean(),
      order_terminal_and_terminal_details: faker.datatype.boolean(),
      change_aml_preference: faker.datatype.boolean(),
      setup_promotions_and_discounts: faker.datatype.boolean(),
    },
  } as TUserDetails;
};
